import { CheckCircle2, Link2Off } from 'lucide-react';

const TYPE_LABEL = { pre_walk: 'Pre-Walk', post_walk: 'Post-Walk', material_selection: 'Material Selection' };
export const reportTypeLabel = (t) => TYPE_LABEL[t] || 'Report';
export const fmtDay = (iso) => (iso ? new Date(iso).toLocaleDateString(undefined, { dateStyle: 'long' }) : '');

const HEAD_FONT = { fontFamily: "'Exo 2', sans-serif" };

/** Branded, mobile-first frame for the public signing page. */
export function SignPageShell({ companyName, logoUrl, children }) {
  return (
    <div className="min-h-screen bg-[#F4F5F7] text-[#111417]" data-testid="sign-page">
      <div className="bg-[#0D1B2A] text-white">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 py-4 flex items-center gap-3">
          {logoUrl && (
            <img src={logoUrl} alt="" data-testid="sign-company-logo" onError={(e) => { e.currentTarget.style.display = 'none'; }}
              className="h-10 w-10 rounded-sm bg-white object-contain p-1 flex-shrink-0" />
          )}
          <div className="min-w-0">
            <div className="text-[10px] font-semibold uppercase tracking-[0.2em] text-white/60">Signature request</div>
            <div className="text-lg font-bold tracking-tight truncate" style={HEAD_FONT} data-testid="sign-company-name">
              {companyName || 'Secure signing'}
            </div>
          </div>
        </div>
      </div>
      <main className="max-w-3xl mx-auto px-4 sm:px-6 py-6 sm:py-10 space-y-6">{children}</main>
      <footer className="max-w-3xl mx-auto px-4 sm:px-6 pb-8 text-[11px] text-[#8A8F99]">Secure electronic signing · Strata</footer>
    </div>
  );
}

const ICONS = { success: CheckCircle2, done: CheckCircle2, dead: Link2Off };
const TONE = {
  success: 'border-l-[#1F8A5B] text-[#1F8A5B]',
  done: 'border-l-[#1F8A5B] text-[#1F8A5B]',
  dead: 'border-l-[#B4463A] text-[#B4463A]',
};

/** A terminal state card: confirmation, already-signed, or a dead-end link. */
export function SignOutcomeCard({ tone, title, testId, children }) {
  const Icon = ICONS[tone] || CheckCircle2;
  return (
    <section
      data-testid={testId}
      className={`bg-white border border-[#D5D8DD] border-l-4 rounded-sm p-6 sm:p-8 space-y-3 animate-in fade-in-0 slide-in-from-bottom-2 duration-300 ${TONE[tone]}`}
    >
      <Icon className="w-8 h-8" strokeWidth={1.75} />
      <h1 className="text-2xl font-bold tracking-tight text-[#111417]" style={HEAD_FONT} data-testid={`${testId}-title`}>{title}</h1>
      <div className="space-y-2 text-sm text-[#5C6370] leading-relaxed">{children}</div>
    </section>
  );
}

export default SignPageShell;
